import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import { graphql, QueryProps } from 'react-apollo';
import { get } from 'lodash';

import { CoreSellFlowCsp } from '../../schemas/rql';

interface IProps {
  cspId?: string;
  make?: string;
  model?: string;
  year?: string;
  finish?: string;
  categories?: string[];
  countryOfOrigin?: string;
  data?: Partial<QueryProps> & CoreSellFlowCsp.Query;
  editForm?: Function;
}

function renderCategories(categories) {
  if (!categories) {
    return null;
  }

  return categories.map(category => <h3 key={category}>{category}</h3>);
}

export const SellCSPPreview: React.SFC<IProps> = (props: IProps) =>
  (get(props.data, 'csp') ? (
    <section className="site-module">
      <div className="site-module__content">

        <div className="sell-preview">
          <div className="sell-preview__image">
            <img src={props.data.csp.image.source} alt={props.data.csp.title} />
          </div>
          <div className="sell-preview__info">
            <div className="sell-preview__header">
              <div className="sell-preview__make-model">
                <h1>{props.make}</h1>
                <h2>{props.model}</h2>
              </div>
              <button type="button" className="sell-preview__edit" onClick={() => props.editForm()}>
                {I18n.t('discovery.SellCSPPreview.edit')}
              </button>
            </div>
            <div className="sell-preview__attributes">
              {props.year && <h3>{props.year}</h3>}
              {props.finish && <h3>{props.finish}</h3>}
              {props.countryOfOrigin && <h3>{I18n.t(`countries.${props.countryOfOrigin}`)}</h3>}
              {renderCategories(props.categories)}
            </div>
          </div>

        </div>
      </div>
    </section>
  ) : null);

const connect = graphql<Partial<IProps>, CoreSellFlowCsp.Query, CoreSellFlowCsp.Variables>(
  gql`
    query Core_SellFlow_CSP($id: String) {
      csp(input: { id: $id }) {
        _id
        title
        image(input: { transform: "card_square" }) {
          source
        }
      }
    }
  `,
  {
    skip: ({ cspId }) => {
      return !cspId;
    },
    options: ({ cspId }) => ({
      ssr: false,
      variables: {
        id: cspId,
      },
    }),
  },
);

export default connect((props: IProps) => SellCSPPreview({ ...props }));
